import { ModuleState } from '@gongxigames/framework/slot/fragments/module/ModuleState';
import { GlobalEventsMapForBackwardCompatibility } from '@gongxigames/framework/slot/events';
import { SingleSetPromotionModule, SingleSetPromotionStates } from '@gongxigames/framework/promotions';

export class SingleSetPromotionInitState extends ModuleState<null, SingleSetPromotionModule, GlobalEventsMapForBackwardCompatibility> {
    protected setupEvents(): void {
        this.setEventHandler('General.Game.STARTED', this.onGameStarted.bind(this));
    }

    private onGameStarted(): void {
        const promotion = this.module.getPromotion();
        let nextState = SingleSetPromotionStates.BASIC;

        if (promotion.hasPromotion()) {
            if (promotion.isActive()) {
                nextState = SingleSetPromotionStates.IN_PROGRESS;
            } else if (this.module.nextActionIsSpin) {
                nextState = SingleSetPromotionStates.START;
            }
        }

        this.module.gotoState(nextState);
    }

    public onEnterState(): void {}
    public onLeaveState(): void {}
}
